import { Field, useFormikContext } from 'formik';

import '../BackofficeMaterial.scss';
import { IFormikBOM } from '../IBackofficeMaterial';
import { get } from 'lodash';
interface IFormikFieldProps {
    label: string;
    name: string;
    type: string;
    step?: number;
}

export const FormikInput = (props: IFormikFieldProps) => {
    const { values, handleChange } = useFormikContext<IFormikBOM>();
    const { label, name, type, step } = props;
    let value = get(values, `${name}`);
    return (
        <>
            {label && <label htmlFor={name}>{label}</label>}
            <Field id={name} type={type} step={step ? step : undefined} name={name} className='d-flex flex-column' value={value} onChange={handleChange} />
        </>
    );
};
